(function(){
  var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  var pop,lastFocus;
  function q(s){return pop?pop.querySelector(s):null}
  function money(cents,cur){try{return new Intl.NumberFormat(document.documentElement.lang||'pl',{style:'currency',currency:cur||'PLN'}).format(cents/100)}catch(e){return (cents/100).toFixed(2)+' zł'}}
  function sized(url,w){if(!url)return '';return url+(url.indexOf('?')>-1?'&':'?')+'width='+w}
  function setCount(n){document.querySelectorAll('[data-owca-cart-count]').forEach(function(el){el.textContent=n;el.hidden=n<1})}
  function open(){
    if(!pop)return;lastFocus=document.activeElement;pop.hidden=false;
    requestAnimationFrame(function(){pop.classList.add('is-open')});
    document.documentElement.style.overflow='hidden';
    var p=q('.owca-pop__panel');if(p)p.focus();
  }
  function close(){
    if(!pop||pop.hidden)return;pop.classList.remove('is-open');document.documentElement.style.overflow='';
    setTimeout(function(){pop.hidden=true},180);
    if(lastFocus&&lastFocus.focus)lastFocus.focus();
  }
  function showItem(item,cart){
    q('[data-owca-pop-item]').hidden=false;q('[data-owca-pop-sum]').hidden=false;q('[data-owca-pop-err]').hidden=true;
    var img=q('[data-owca-pop-img]');var src=(item.featured_image&&item.featured_image.url)||item.image;
    img.src=sized(src,240);img.alt=item.product_title||'';
    q('[data-owca-pop-vendor]').textContent=item.vendor||'';
    q('[data-owca-pop-name]').textContent=item.product_title||item.title;
    var opts=(item.options_with_values||[]).filter(function(o){return o.name!=='Title'}).map(function(o){return o.name+': '+o.value}).join(', ');
    q('[data-owca-pop-variant]').textContent=opts;
    q('[data-owca-pop-price]').textContent=money(item.final_line_price,cart.currency)+(item.quantity>1?' ('+item.quantity+' × '+money(item.final_price,cart.currency)+')':'');
    q('[data-owca-pop-count]').textContent=cart.item_count;
    q('[data-owca-pop-total]').textContent=money(cart.total_price,cart.currency);
    open();
  }
  function showError(msg){
    q('[data-owca-pop-item]').hidden=true;q('[data-owca-pop-sum]').hidden=true;
    var e=q('[data-owca-pop-err]');e.textContent=msg||pop.getAttribute('data-err');e.hidden=false;open();
  }
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(!pop||!f.matches||f.hasAttribute('data-owca-no-ajax'))return;
    var action=f.getAttribute('action')||'';
    if(action.indexOf('/cart/add')===-1)return;
    e.preventDefault();
    var btn=f.querySelector('[type=submit]');if(btn&&btn.disabled)return;if(btn)btn.setAttribute('aria-busy','true');
    var fd=new FormData(f);
    fetch(root+'cart/add.js',{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:fd})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})})
      .then(function(res){
        if(!res.ok){showError(res.j&&(res.j.description||res.j.message));return}
        var item=res.j.items?res.j.items[0]:res.j;
        return fetch(root+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(cart){setCount(cart.item_count);showItem(item,cart)});
      })
      .catch(function(){showError()})
      .finally(function(){if(btn)btn.removeAttribute('aria-busy')});
  });
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-owca-pop-close]')){e.preventDefault();close();return}
    var qb=e.target.closest('[data-owca-qty]');
    if(qb){var wrap=qb.closest('.owca-qty');var inp=wrap&&wrap.querySelector('input');if(!inp)return;var v=Math.max(0,(parseInt(inp.value,10)||0)+parseInt(qb.getAttribute('data-owca-qty'),10));inp.value=v;var f=inp.form;if(f){if(f.requestSubmit){f.requestSubmit()}else{f.submit()}}}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close()});
  function init(){pop=document.getElementById('owca-pop')}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
})();